import { PIPELINE, DEAD, REFINANCE, ADDING_SUPPLEMENTAL } from "constants/status";
import { ACCESS_TYPE_GROUP, ACCESS_TYPE_PIPELINE_DEAL, ACCESS_TYPE_PORTFOLIO_DEAL } from "constants/accessTypes";
import React, { Component, Fragment } from "react";
import _ from "lodash";
import { compose } from "redux";
import { connect } from "react-redux";
import {
  getGuestById,
  addGuestToDeals,
  removeGuestFromDeals,
  addGuestToFunds,
  removeGuestFromFunds,
  updateGuestPermissions,
  setGuestAccessToAllItems,
  inviteGuestToTargetEmail,
  resendGuestSetupEmail,
} from "store/state/guest";
import { fetchDealsNames } from "store/state/deal";
import { getFundNames } from "store/state/enumeratedTypes";
import { AssignedItems } from "./AssignedItems";
import styled from "styled-components";
import AssociatedGuestGroupsSection from "./AssociatedGuestGroupsSection";
import Button from "@material-ui/core/Button";
import { getAllGuestGroups } from "store/state/guestGroup";
import PipelineDealPermissionDash from "../util/PipelineDealPermissionDash";
import PortfolioPermissionDash from "../util/PortfolioPermissionDash";
import { ToastSuccess } from "components/Global/Toasts/Toasty";

const PermsHeader = styled.span`
    font-size: 24px;
`
const BackButton = styled(Button)`
  && {
    margin-top: -3px;
    border-radius: 0;
    color: #2196f3;
    background: none;
    float: right;
  }
  &&:hover {
    background: #f6f6f6;
  }
  
`;

const BlueButton = styled(Button)`
  && {
    margin-top: -3px;
    border-radius: 0;
    color: #2196f3;
    background: none;
  }
  &&:hover {
    background: #f6f6f6;
  }
  
`;

const SectionDivider = styled.hr`
  margin-top: 15px;
  border: 1px solid #dddddd;
`;

class GuestIndividualSettingsPage extends Component {
  constructor(props) {
    super(props);
    this.props.fetchDealsNames();
    this.props.getFundNames();
    this.state = {
      metricsPerm: "full",
      showPipeline : true,
      showPortfolio : true,
      pipelineToggledOn: false,
      portfolioToggledOn: false,
    };
  }

  componentDidMount(){
    this.props.getGuestById({id: this.props.match.params.guestId, includeAuxData: true});
  }

  onAddFullPortfolio = () => {
    this.props.setGuestAccessToAllItems({ guestId: this.props.currentGuest.id, itemType: "portfolio", hasAccess: true });
    this.props.inviteGuestToTargetEmail({
      guest:this.props.currentGuest,
      scope:"fullPortfolio",
    });
  }

  onAddFullPipeline = () => {
    this.props.setGuestAccessToAllItems({ guestId: this.props.currentGuest.id, itemType: "pipeline", hasAccess: true });
    this.props.inviteGuestToTargetEmail({
      guest:this.props.currentGuest,
      scope:"fullPipeline",
    });
  }

  onAddFunds = (items) => {
    this.props.addGuestToFunds({ guestId: this.props.currentGuest.id, fundIds: items.map(item => item.id) });
    this.props.inviteGuestToTargetEmail({
      guest:this.props.currentGuest,
      scope:"fund",
      target: items,
    });
  }

  onAddDeals = (items, type) => {
    if(type.toLowerCase()=="portfolio" || type.toLowerCase()=="sold") {
      this.props.addGuestToDeals({ guestId: this.props.currentGuest.id, dealIds: items.map(item => item.id), accessTypeId: ACCESS_TYPE_PORTFOLIO_DEAL });
    }else if (type.toLowerCase()=="pipeline" || type.toLowerCase()=="dead") {
      this.props.addGuestToDeals({ guestId: this.props.currentGuest.id, dealIds: items.map(item => item.id), accessTypeId: ACCESS_TYPE_PIPELINE_DEAL });
    }
    this.props.inviteGuestToTargetEmail({
      guest:this.props.currentGuest,
      scope:"deal",
      target: items,
      targetDealStatus: type,
    });
  }

  renderAssignedPipelineDeals() {
    if (!this.props.currentGuest.guestAccesses || !this.props.deals) {
      return <div>Loading...</div>;
    }
    
    return (
      <Fragment>
        <AssignedItems
          itemName="Deal"
          longItemName="Pipeline Deal"
          guestContact={this.props.currentGuest.contact}
          assignedItems={this.props.deals.filter(deal => (deal.dealStatusId === PIPELINE || deal.dealStatusId === DEAD || deal.dealStatusId === REFINANCE || deal.dealStatusId === ADDING_SUPPLEMENTAL) && this.props.currentGuest.guestAccesses.some(guestAccess => guestAccess.accessTypeId === ACCESS_TYPE_PIPELINE_DEAL && guestAccess.modelId === deal.id))}
          assignedToAllItems={this.props.currentGuest.allowAccessToAllPipelineDeals}
          availableItems={this.props.deals.filter(deal => (deal.dealStatusId === PIPELINE || deal.dealStatusId === DEAD || deal.dealStatusId === REFINANCE || deal.dealStatusId === ADDING_SUPPLEMENTAL) && !this.props.currentGuest.guestAccesses.some(guestAccess => guestAccess.accessTypeId === ACCESS_TYPE_PIPELINE_DEAL && guestAccess.modelId === deal.id))}
          onAddItems={(items) => {this.onAddDeals(items,"pipeline")}}
          onRemoveItems={items => this.props.removeGuestFromDeals({ guestId: this.props.currentGuest.id, dealIds: items, accessTypeId: ACCESS_TYPE_PIPELINE_DEAL })}
          onAddToAllItems={this.onAddFullPipeline}
          onRemoveFromAllItems={() => this.props.setGuestAccessToAllItems({ guestId: this.props.currentGuest.id, itemType: "pipeline", hasAccess: false })}
          addToAllItemsLabel="Give access to all Pipeline Deals. (This includes all future Pipeline Deals.)"
          hasAllItemsMessage="This guest has access to all Pipeline Deals."
          removeAllItemsMessage="Revoke access to all Pipeline Deals."
          getInvitedByContact={item => this.props.currentGuest.guestAccesses.filter(guestAccess => guestAccess.accessTypeId === ACCESS_TYPE_PIPELINE_DEAL && guestAccess.modelId === item.id)[0].invitedBy}
        />
      </Fragment>
    );
  }

  renderAssignedPortfolioDeals() {
    if (!this.props.currentGuest.guestAccesses || !this.props.deals) {
      return <div>Loading...</div>;
    }
    return (
      <Fragment>
        <AssignedItems
          itemName="Deal"
          longItemName="Portfolio Deal"
          guestContact={this.props.currentGuest.contact}
          assignedItems={this.props.deals.filter(deal => deal.dealStatusId !== PIPELINE && deal.dealStatusId !== DEAD && this.props.currentGuest.guestAccesses.some(guestAccess => guestAccess.accessTypeId === ACCESS_TYPE_PORTFOLIO_DEAL && guestAccess.modelId === deal.id))}
          assignedToAllItems={this.props.currentGuest.allowAccessToAllPortfolioDeals}
          availableItems={this.props.deals.filter(deal => deal.dealStatusId !== PIPELINE && deal.dealStatusId !== DEAD && !this.props.currentGuest.guestAccesses.some(guestAccess => guestAccess.accessTypeId === ACCESS_TYPE_PORTFOLIO_DEAL && guestAccess.modelId === deal.id))}
          onAddItems={(items) => {this.onAddDeals(items,"portfolio")}}
          onRemoveItems={items => this.props.removeGuestFromDeals({ guestId: this.props.currentGuest.id, dealIds: items, accessTypeId: ACCESS_TYPE_PORTFOLIO_DEAL })}
          onAddToAllItems={this.onAddFullPortfolio}
          onRemoveFromAllItems={() => this.props.setGuestAccessToAllItems({ guestId: this.props.currentGuest.id, itemType: "portfolio", hasAccess: false })}
          addToAllItemsLabel="Give access to entire Portfolio. (This includes all future Portfolio Deals.)"
          hasAllItemsMessage="This guest has access to the entire Portfolio, including future deals."
          removeAllItemsMessage="Revoke access to all Portfolio Deals."
          getInvitedByContact={item => this.props.currentGuest.guestAccesses.filter(guestAccess => guestAccess.accessTypeId === ACCESS_TYPE_PORTFOLIO_DEAL && guestAccess.modelId === item.id)[0].invitedBy}
        />
      </Fragment>
    );
  }

  renderAssignedFunds() {
    if (!this.props.currentGuest.guestAccesses || !this.props.funds) {
      return <div>Loading...</div>;
    }
    return (
      <Fragment>
        <AssignedItems
          itemName="Group"
          longItemName="Group"
          guestContact={this.props.currentGuest.contact}
          assignedItems={this.props.funds.filter(fund => this.props.currentGuest.guestAccesses.some(guestAccess => guestAccess.accessTypeId === ACCESS_TYPE_GROUP && guestAccess.modelId === fund.id))}
          assignedToAllItems={this.props.currentGuest.allowAccessToAllPortfolioDeals}
          availableItems={this.props.funds.filter(fund => !this.props.currentGuest.guestAccesses.some(guestAccess => guestAccess.accessTypeId === ACCESS_TYPE_GROUP && guestAccess.modelId === fund.id))}
          onAddItems={items=>this.onAddFunds(items)}
          onRemoveItems={items => this.props.removeGuestFromFunds({ guestId: this.props.currentGuest.id, fundIds: items })}
          onAddToAllItems={this.onAddFullPortfolio}
          onRemoveFromAllItems={() => this.props.setGuestAccessToAllItems({ guestId: this.props.currentGuest.id, itemType: "portfolio", hasAccess: false })}
          addToAllItemsLabel="Give access to entire Portfolio. (This includes all future Portfolio Deals.)"
          hasAllItemsMessage="This guest has access to the entire Portfolio, including future deals."
          removeAllItemsMessage="Revoke access to all Portfolio Deals."
          getInvitedByContact={item => this.props.currentGuest.guestAccesses.filter(guestAccess => guestAccess.accessTypeId === ACCESS_TYPE_GROUP && guestAccess.modelId === item.id)[0].invitedBy}
        />
      </Fragment>
    );
  }

    render(){
        const currentGuest = this.props.currentGuest;
        let quoteCheck = this.props.currentGuest.pipelineAllowQuoteStatus;
        let guestName = currentGuest && currentGuest.contact ? 
                `${currentGuest.contact.firstName} ${currentGuest.contact.lastName}`.toUpperCase() : "";
        return(<Fragment>
            <PermsHeader>{`GUEST PERMISSIONS / ${guestName}`} 
              <BlueButton onClick={()=>{this.props.resendGuestSetupEmail({guest:currentGuest}); ToastSuccess("Sending...")}}>
                RESEND INVITE
              </BlueButton>
              <BackButton onClick={this.props.history.goBack}>
                <span>Go Back</span>
              </BackButton>
            </PermsHeader>
            <AssociatedGuestGroupsSection 
                currentGuest = {currentGuest} 
                refreshCurrentGuest = {()=>{
                  this.props.getGuestById({id: this.props.match.params.guestId, includeAuxData: true});
                  this.props.getAllGuestGroups();
                }}
                allGuestGroups = {this.props.allGuestGroups}
                />
            <div style={{width:"75%"}}>

            <SectionDivider />

            <PipelineDealPermissionDash 
            showHeader
            onClickView={()=>this.props.updateGuestPermissions({guestId:currentGuest.id, pipelinePerms:"view"})}
            onClickEdit={()=>this.props.updateGuestPermissions({guestId:currentGuest.id, pipelinePerms:"edit"})}
            currentPerm={currentGuest.pipelinePermission ? currentGuest.pipelinePermission.value.toLowerCase() : ""}
            onClickQuoteStatus={()=>this.props.updateGuestPermissions({guestId:currentGuest.id, quoteStatus: !quoteCheck})}
            isQuoteStatusChecked={quoteCheck}
            onClear={()=>{this.props.updateGuestPermissions({guestId:currentGuest.id, pipelinePerms:"none", quoteStatus:false, pipelineProjectionsEnabled: false}); this.setState({pipelineToggledOn:false})}}
            isMinimized={!(this.state.pipelineToggledOn || currentGuest.pipelinePermission || quoteCheck)}
            onShow={()=>this.setState({pipelineToggledOn:true})}
            projectionsEnabled={!!currentGuest.pipelineProjections}
            toggleProjections={()=>this.props.updateGuestPermissions({guestId:currentGuest.id, pipelineProjectionsEnabled: !currentGuest.pipelineProjections})}
            />   

            <br/>
            {this.renderAssignedPipelineDeals()}
            <SectionDivider />

            <PortfolioPermissionDash 
            showHeader
            currentPerm = {currentGuest.portfolioPermission ? currentGuest.portfolioPermission.value : ""}
            onClickView={()=>this.props.updateGuestPermissions({guestId:currentGuest.id, portfolioPerms:"view"})}
            onClickEdit={()=>this.props.updateGuestPermissions({guestId:currentGuest.id, portfolioPerms:"edit"})}
            onToggleMetrics={()=>this.props.updateGuestPermissions({guestId: currentGuest.id, metricsPerm: currentGuest.portfolioMetricsPermission ? "none" : "restricted"})}
            metricsPerm={currentGuest.portfolioMetricsPermission ? currentGuest.portfolioMetricsPermission.value.toLowerCase() : "none"}
            setMetricsPerm={(perm)=>this.props.updateGuestPermissions({guestId:currentGuest.id, metricsPerm:perm})}
            onClear={()=>{this.props.updateGuestPermissions({guestId:currentGuest.id, portfolioPerms:"none", metricsPerm:"none", portfolioProjectionsEnabled: false}); this.setState({portfolioToggledOn:false})}}
            isMinimized={!(this.state.portfolioToggledOn || currentGuest.portfolioPermission || currentGuest.portfolioMetricsPermission)}
            onShow={()=>this.setState({portfolioToggledOn:true})}
            projectionsEnabled={!!currentGuest.portfolioProjections}
            lenderReportingEnabled={!!currentGuest.portfolioLenderReporting}
            toggleProjections={()=>this.props.updateGuestPermissions({guestId:currentGuest.id, portfolioProjectionsEnabled: !currentGuest.portfolioProjections})}
            toggleLenderReporting={()=>this.props.updateGuestPermissions({guestId: currentGuest.id, portfolioLenderReporting: !currentGuest.portfolioLenderReporting})}
            isSysAdmin={(this.props.authentication && this.props.authentication.isSystemAdmin)}
            /> 

            <Fragment>
              <br/>
              {this.renderAssignedPortfolioDeals()}
              {!this.props.currentGuest.allowAccessToAllPortfolioDeals &&
                <Fragment>
                  <br/>
                  <SectionDivider />

                  {this.renderAssignedFunds()}
                </Fragment>
              }
            </Fragment>

          </div> 

        </Fragment>)
    }
}
function mapStateToProps({guest, guestGroup, deal, enumeratedTypes, authentication}) {
  return {
    currentGuest: guest.guest,
    allGuestGroups: guestGroup.guestGroups,
    authentication: authentication,
    deals: deal.dealsNames,
    funds: enumeratedTypes.enumeratedTypes
      ? enumeratedTypes.enumeratedTypes.fund_names.funds
      : []
    };
}

export default compose(
  connect(
    mapStateToProps,
    {
        getGuestById,
        getAllGuestGroups,
        updateGuestPermissions,
        fetchDealsNames,
        getFundNames,
        addGuestToDeals,
        removeGuestFromDeals,
        addGuestToFunds,
        removeGuestFromFunds,
        inviteGuestToTargetEmail,
        resendGuestSetupEmail,
        setGuestAccessToAllItems
    }
  )
)(GuestIndividualSettingsPage);
